import { render } from "./GlobalSnackBar.vue?vue&type=template&id=5093d197"
import script from "./GlobalSnackBar.vue?vue&type=script&lang=js"
export * from "./GlobalSnackBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__